import React from 'react';
import { motion } from 'framer-motion';
import { Play, ListTodo } from 'lucide-react';
interface StartScreenProps {
  queueLength: number;
  onStart: () => void;
}
export function StartScreen({
  queueLength,
  onStart
}: StartScreenProps) {
  return <div className="flex-1 flex items-center justify-center bg-stone-50 p-8" data-id="element-158">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-stone-200 p-8 text-center" data-id="element-159">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6" style={{
        backgroundColor: 'rgba(197, 165, 90, 0.15)'
      }} data-id="element-160">
          <ListTodo className="w-8 h-8" style={{
          color: '#C5A55A'
        }} data-id="element-161" />
        </div>

        <h1 className="text-2xl font-bold text-stone-900 mb-2" data-id="element-162">
          Ready to start your queue?
        </h1>
        <p className="text-stone-600 mb-8" data-id="element-163">
          You have{' '}
          <strong className="text-stone-900" data-id="element-164">{queueLength} loans</strong> in
          your call list today. Loans will be served one at a time.
        </p>

        <button onClick={onStart} className="w-full flex items-center justify-center gap-2 text-white font-semibold py-3 px-6 rounded-xl transition-colors shadow-sm hover:shadow" style={{
        backgroundColor: '#C5A55A'
      }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#B8963E'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#C5A55A'} data-id="element-165">
          <Play className="w-5 h-5" data-id="element-166" />
          Start Processing
        </button>
      </motion.div>
    </div>;
}